import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { fullNameLabel } from "app/_helpers/helper";
import { decodeBase64 } from "app/_helpers/reactHelper";
import {
  EMPLOYEE_MEDICAL_CATEGORY,
  employeeFormLabel,
} from "app/_pages/UserManagement/Employee/Constant";
import { CommmonService } from "app/_services/CommonService/CommonService";
import React, { useCallback, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import toastr from "toastr";
import { STAFF_TYPE_KEY } from "./CONSTANT";
import { contractorPersonFormLabel } from "app/_pages/UserManagement/ContractorPerson/Constant";
import { TRAINEE_TYPE, TRAINING_STATUS_VIEW } from "../TrainingManagement/CONSTANTS";
import { MEDICAL_STATUS_VIEW } from "../Medical/Constant";
import MedicalHistoryList from "app/_pages/UserManagement/Employee/Component/MedicalHistoryList";
import TrainingHistoryList from "app/_pages/UserManagement/Employee/Component/TrainingHistoryList";
import ImageInput from "app/Components/ImageInput/ImageInput";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";

const PersonalInfoDetails = () => {
  const [form, setForm] = useState({});
  const [historyListData, setHistoryListData] = useState([]);
  const [trainingHistoryList, setTrainingHistoryList] = useState([]);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const encryptedData = queryParams.get("data");

  let origanalQuery = {};
  if (encryptedData) {
    const decodedQuery = decodeBase64(encryptedData);
    origanalQuery = Object.fromEntries(new URLSearchParams(decodedQuery));
  }

  const fetchData = useCallback(
    async (queryFilter) => {
      const response = await CommmonService.fetchPersonalInfoDetails(queryFilter);
      if (!response?.status) {
        return toastr.error(response?.message);
      }
      const { data } = response;
      const isContractor = origanalQuery?.staffType === STAFF_TYPE_KEY.contractorPerson;
      const formattedData = {
        ...data,
        formAObj: data?.employeeFormA || data?.contractorFormA || {},
        staffCode: isContractor
          ? data?.contractors?.contractorCode +
              " / " +
              data?.contractors?.contractorEntityCode || ""
          : data?.employeeId,
        contractorName: data?.contractors?.contractorLegalEntity || "",
      };
      // for medical history
      const historyRecord = (data?.employeeMedicalHistory || []).map((d, i) => ({
        ...d,
        sid: i + 1,
        createdAtView: d?.createdAt ? DDMMYYYYFormat(d?.createdAt) : "",
        specialMedicalExamCategoryName:
          EMPLOYEE_MEDICAL_CATEGORY[d?.specialMedicalExamCategory],
        specialMedicalExamEligibility: d?.isMedicalAssined ? "YES" : "NO",
        medicalDueDateView: d?.medicalAssigneeData?.dueDate
          ? DDMMYYYYFormat(d?.medicalAssigneeData?.dueDate)
          : "",
        medicalStatusView: MEDICAL_STATUS_VIEW[d?.medicalAssigneeData?.medicalStatus],
      }));
      const trainingRecord = (data?.employeeTrainingHistory || []).map((d, i) => ({
        ...d,
        sid: i + 1,
        createdAtView: d.createdAt ? DDMMYYYYFormat(d.createdAt) : "",
        trainingDesignationName: d?.newBasicTrainingDesignationData?.name,
        trainingEligibility: d?.isTrainingAssined ? "YES" : "NO",
        trainingDueDateView: d?.trainingAssigneeData?.dueDate
          ? DDMMYYYYFormat(d?.trainingAssigneeData?.dueDate)
          : "",
        trainingStatusView: TRAINING_STATUS_VIEW[d?.trainingAssigneeData?.trainingStatus],
      }));
      setTrainingHistoryList(trainingRecord);
      setHistoryListData(historyRecord);
      setForm(formattedData);
    },
    [origanalQuery?.staffType]
  );
  // console.log("form--------", form);

  useEffect(() => {
    if (!encryptedData) return;
    const queryFilter = `?search=${encryptedData}`;
    fetchData(queryFilter);
  }, [encryptedData, fetchData]);

  return (
    <div className="p-0 personalIn_fo">
      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title">
            <h3 class="text-capitalize mb-1">View Personnel Info</h3>
          </Card.Title>
          <ImageInput
            name={"profilePicture"}
            value={
              form?.formAObj?.profilePicture
                ? `${URL_CONFIG.IMG_URL}${form?.formAObj?.profilePicture}`
                : ""
            }
            // height={height}
            width={100}
            disabled
          />
          <div className="mt-3">
            <TitleHeading title="Basic Details" />
            <Row>
              <Col md={3}>
                {origanalQuery?.staffType === STAFF_TYPE_KEY.contractorPerson ? (
                  <>
                    <h5>{contractorPersonFormLabel["srNo"]}</h5>
                    <p>{form?.srNo}</p>
                  </>
                ) : (
                  <>
                    <h5>{employeeFormLabel["employeeId"]}</h5>
                    <p>{form?.employeeId}</p>
                  </>
                )}
              </Col>
              <Col md={3}>
                <h5>{"Staff Type"}</h5>
                <p>{TRAINEE_TYPE[origanalQuery?.staffType]}</p>
              </Col>
              <Col md={3}>
                <h5>{"Name"}</h5>
                <p>{fullNameLabel(form)}</p>
              </Col>
              {origanalQuery?.staffType === STAFF_TYPE_KEY.employee && (
                <Col md={3}>
                  <h5>{employeeFormLabel["email"]}</h5>
                  <p>{form?.email}</p>
                </Col>
              )}
              <Col md={3}>
                <h5>{employeeFormLabel["mobileNumber"]}</h5>
                <p>{form?.mobileNumber}</p>
              </Col>
              <Col md={3}>
                <h5>{employeeFormLabel["aadharNumber"]}</h5>
                <p>{form?.aadharNumber}</p>
              </Col>
              <Col md={3}>
                <h5>{employeeFormLabel["dob"]}</h5>
                <p>{form?.dob ? DDMMYYYYFormat(form?.dob) : ""}</p>
              </Col>
              <Col md={3}>
                <h5>{employeeFormLabel["gender"]}</h5>
                <p>{form?.gender}</p>
              </Col>
              <Col md={3}>
                <h5>{employeeFormLabel["employmentStatus"]}</h5>
                <p>{form?.employmentStatus}</p>
              </Col>
              <Col md={3}>
                <h5>{"Guardian Type"}</h5>
                <p>{form?.formAObj?.guardianType}</p>
              </Col>
              <Col md={3}>
                <h5>{`${
                  form?.formAObj?.guardianType === "spouse" ? "Spouse" : "Father's"
                } Name`}</h5>
                <p>{form?.formAObj?.fathersName}</p>
              </Col>
              <Col md={3}>
                <h5>{"Nationality"}</h5>
                <p>{form?.formAObj?.nationality}</p>
              </Col>
              <Col md={3}>
                <h5>{"Mine Name"}</h5>
                <p>{form?.ehsSite?.name}</p>
              </Col>
              <Col md={3}>
                <h5>{"Mine Code (MOL)"}</h5>
                <p>{form?.ehsSite?.siteId}</p>
              </Col>
            </Row>
          </div>
          <div className="mt-2">
            <TitleHeading title="Employment Info" />
            <Row>
              <Col md={3}>
                <h5>{`${
                  origanalQuery?.staffType === STAFF_TYPE_KEY.contractorPerson
                    ? "Contractor"
                    : "Employee"
                } Code`}</h5>
                <p>{form?.staffCode}</p>
              </Col>
              {origanalQuery?.staffType === STAFF_TYPE_KEY.contractorPerson && (
                <Col md={3}>
                  <h5>{"Name of the Contractor"}</h5>
                  <p>{form?.contractorName}</p>
                </Col>
              )}
              <Col md={3}>
                <h5>{"Form A"}</h5>
                <p>
                  {origanalQuery?.staffType === STAFF_TYPE_KEY.contractorPerson
                    ? form?.srNo
                    : form?.formAObj?.serialNumberOmc || ""}
                </p>
              </Col>
              <Col md={3}>
                <h5>{employeeFormLabel["dateOfJoining"]}</h5>
                <p>{form?.dateOfJoining ? DDMMYYYYFormat(form?.dateOfJoining) : null}</p>
              </Col>
              <Col md={3}>
                <h5>{employeeFormLabel["dateOfSeparation"]}</h5>
                <p>
                  {form?.dateOfSeparation ? DDMMYYYYFormat(form?.dateOfSeparation) : null}
                </p>
              </Col>
              <Col md={3}>
                <h5>{employeeFormLabel["designation"]}</h5>
                <p>{form?.designation}</p>
              </Col>
            </Row>
          </div>
          <div className="mt-2">
            <TitleHeading title="Medical Certificates" />
            <Row>
              <Col md={3}>
                <h5>{"IME Certificate No."}</h5>
                <p>{form?.employeeMedicalData?.imeCertificateId || "NA"}</p>
              </Col>
              <Col md={3}>
                <h5>{"IME Date"}</h5>
                <p>
                  {form?.employeeMedicalData?.imeApproveDate
                    ? DDMMYYYYFormat(form?.employeeMedicalData?.imeApproveDate)
                    : "NA"}
                </p>
              </Col>
              <Col md={3}>
                <h5>{"PME Certificate No."}</h5>
                <p>{form?.employeeMedicalData?.pmeCertificateId || "NA"}</p>
              </Col>
              <Col md={3}>
                <h5>{"PME Date"}</h5>
                <p>
                  {form?.employeeMedicalData?.pmeApproveDate
                    ? DDMMYYYYFormat(form?.employeeMedicalData?.pmeApproveDate)
                    : "NA"}
                </p>
              </Col>
              <Col md={3}>
                <h5>{"SME Certificate No."}</h5>
                <p>{form?.employeeMedicalData?.smeCertificateId || "NA"}</p>
              </Col>
              <Col md={3}>
                <h5>{"SME Date"}</h5>
                <p>
                  {form?.employeeMedicalData?.smeApproveDate
                    ? DDMMYYYYFormat(form?.employeeMedicalData?.smeApproveDate)
                    : "NA"}
                </p>
              </Col>
            </Row>
          </div>
          <div className="mt-2">
            <TitleHeading title="Training Certificates" />
            <Row>
              <Col md={3}>
                <h5>{"Initial Training Certificate No."}</h5>
                <p>{form?.trainingAssigneeData?.initialTrainingCertificateId || "NA"}</p>
              </Col>
              <Col md={3}>
                <h5>{"Initial Training Date"}</h5>
                <p>
                  {form?.trainingAssigneeData?.initialTrainingApproveDate
                    ? DDMMYYYYFormat(
                        form?.trainingAssigneeData?.initialTrainingApproveDate
                      )
                    : "NA"}
                </p>
              </Col>
              <Col md={3}>
                <h5>{"Refresher Training Certificate No."}</h5>
                <p>{form?.trainingAssigneeData?.refreshTrainingCertificateId || "NA"}</p>
              </Col>
              <Col md={3}>
                <h5>{"Refresher Training Date"}</h5>
                <p>
                  {form?.trainingAssigneeData?.refreshTrainingApproveDate
                    ? DDMMYYYYFormat(
                        form?.trainingAssigneeData?.refreshTrainingApproveDate
                      )
                    : "NA"}
                </p>
              </Col>
            </Row>
          </div>
          <div className="mt-2">
            <TitleHeading title="Medical SME History" />
            <MedicalHistoryList
              data={historyListData}
              onListHistory
              searchFlag={false}
              isNoPagination
            />
          </div>
          <div className="mt-2">
            <TitleHeading title="Training Designation History" />
            <TrainingHistoryList
              data={trainingHistoryList}
              onListHistory
              searchFlag={false}
              isNoPagination
            />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default PersonalInfoDetails;

export const TitleHeading = ({ title }) => {
  return (
    <div className="p-1 pt-2 pl-2 mb-2 text-dark" style={{ backgroundColor: "#6ed0f7" }}>
      <h5>{title}</h5>
    </div>
  );
};
